import PropTypes from 'prop-types';
import { QRCodeCanvas } from 'qrcode.react';
import { makeStyles, Typography } from '@material-ui/core';
import classNames from 'classnames';
import InputField from '../inputField';
import { ACTION_BUTTON_TYPES } from '../actionButton/config';
import ActionButton from '../actionButton';

const useStyles = makeStyles(({ palette: { primary }, spacing }) => ({
  root: {
    width: 500,
    height: 683,
  },
  wrapper: {
    justifyContent: 'center',
    gap: 16,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
  },
  title: {
    paddingRight: 0,
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex',
    fontSize: 24,
  },
  input: {
    borderRadius: 32,
    border: `1px solid ${primary.bluish7}`,
    lineHeight: '24px',
    paddingLeft: spacing(4),
    paddingRight: spacing(4),
    gap: 4,
  },
  downloadWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },
  inputWrapper: {
    width: '100%',
  },
  error: {
    position: 'absolute',
    bottom: -20,
  },
  helpText: {
    marginTop: spacing(8),
    display: 'flex',
    justifyContent: 'center',
  },
  recoveryCodes: {
    textAlign: 'start',
  },
}));

const QrCode = ({
  translations,
  showQRCode = false,
  hasRecoveryCodes = false,
  isAuthenticationView = false,
  isDisableAuthenticationView = false,
  label = '',
  secret = '',
  otpCode = '',
  size = 300,
  hasError = false,
  errorMessage = '',
  handleChange,
  handleDownload = () => {},
  customWrapperClass = undefined,
}) => {
  const classes = useStyles();

  return (
    <div className={classNames(classes.wrapper, customWrapperClass)}>
      {showQRCode && (
        <>
          <Typography variant="body1">{translations.scanMessage}</Typography>
          <QRCodeCanvas
            size={size}
            value={`otpauth://totp/kadar:${label}?secret=${secret}&issuer=kadar`}
            level="L"
            bgColor="#ffffff"
            fgColor="#000000"
          />
          <Typography variant="body1">{translations.secretMessage}</Typography>
          <Typography variant="h5">{secret}</Typography>
        </>
      )}
      <div className={classes.inputWrapper}>
        <InputField
          className={classes.input}
          customErrorClass={classes.error}
          label={showQRCode ? translations.codeLabel : ''}
          name="code"
          placeholder={translations.codePlaceholder}
          value={otpCode}
          error={hasError}
          errorMessage={errorMessage}
          onChange={handleChange}
          fullWidth
        />
        {isAuthenticationView &&
          !showQRCode &&
          !isDisableAuthenticationView &&
          !hasRecoveryCodes && (
            <Typography
              className={classNames(classes.helpText)}
              variant="body2"
            >
              {translations.helpText}
            </Typography>
          )}
      </div>
      {hasRecoveryCodes && (
        <div className={classes.downloadWrapper}>
          <ActionButton
            type={ACTION_BUTTON_TYPES.DOWNLOAD}
            onClickHandler={handleDownload}
          />
          <Typography variant="subtitle1" className={classes.recoveryCodes}>
            {translations.downloadRecoveryCodes}
          </Typography>
        </div>
      )}
    </div>
  );
};

QrCode.propTypes = {
  translations: PropTypes.object.isRequired,
  customWrapperClass: PropTypes.string,
  showQRCode: PropTypes.bool,
  hasRecoveryCodes: PropTypes.bool,
  isAuthenticationView: PropTypes.bool,
  isDisableAuthenticationView: PropTypes.bool,
  hasError: PropTypes.bool,
  errorMessage: PropTypes.string,
  size: PropTypes.number,
  label: PropTypes.string,
  secret: PropTypes.string,
  otpCode: PropTypes.string,
  handleChange: PropTypes.func.isRequired,
  handleDownload: PropTypes.func,
};

export default QrCode;
